module.exports = __webpack_public_path__ + "img/Group 39237.908fc1b0.png";